import { Navbar, Container } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import SideBar from "./SideBar";

export default function AppNavbar({ title }: { title: string }) {
  return (
    <Navbar
      fixed="top"
      expand="sm"
      className="px-2 px-sm-3"
      style={{
        backgroundColor: "var(--navbar-bg)",
        color: "var(--navbar-text)",
      }}
    >
      <Container
        fluid
        className="d-flex justify-content-between align-items-center"
      >
        {/* Brand / Title on the left */}
        <Navbar.Brand
          as={NavLink}
          to="/"
          className="fw-bold text-uppercase"
          style={{
            letterSpacing: ".06rem",
            fontSize: "17px",
            color: "var(--navbar-text)",
          }}
        >
          {title}
        </Navbar.Brand>

        {/* Sidebar Toggle on the right */}
        <SideBar />
      </Container>
    </Navbar>
  );
}
